import { Injectable} from '@angular/core';
import { Http, Headers } from '@angular/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { utils } from 'src/app/utils/utils';

@Injectable()
export class ViajesService {
    public headers = new Headers({'Content-Type': 'application/json; charset=utf-8', 'Accept': 'application/json, text/javascript, /;'});
    _utils: utils;

    constructor(private _http: Http) {
        this._utils = new utils();
    }

    consultarViajes(params): Observable<any[]> {
        let json = JSON.stringify(params)

        return this._http.post(`${this._utils.url}Viajes/consultarPermisionarioViajes`, json, {headers: this.headers}).pipe(
        map((res: any) => {
            try {
                return JSON.parse(res.text());
            }
            catch (error){
                console.log(error);
                return null;
            }  
        }));
    }

    consultarRutaTransportistaEstatus(): Observable<any[]> {
        return this._http.get(`${this._utils.url}Viajes/consultarRutaTransportistaEstatus`, {headers: this.headers}).pipe(
        map((res: any) => {
            try {
                return JSON.parse(res.text());
            }
            catch (error){
                console.log(error);
                return null;
            }  
        }));
    }

    consultarRutaEstausViaje(): Observable<any[]> {
        return this._http.get(`${this._utils.url}Viajes/consultarRutaEstatusViaje`, {headers: this.headers}).pipe(
        map((res: any) => {
            try {
                return JSON.parse(res.text());
            }
            catch (error){
                console.log(error);
                return null;
            }  
        }));
    }

    actualizarRutaEstausViaje(idRuta, idRutaEstatus, activoZAM): Observable<any[]> {
        return this._http.get(`${this._utils.url}Viajes/actualizarRutaEstatusViaje?idRuta=`+idRuta+`&idRutaEstatus=`+idRutaEstatus + `&activoZAM=`+activoZAM, 
        {headers: this.headers}).pipe(
        map((res: any) => {
            try {
                return JSON.parse(res.text());
            }
            catch (error){
                console.log(error);
                return null;
            }  
        }));
    }

    consultarEventoTipos(): Observable<any[]> {
        return this._http.get(`${this._utils.url}Viajes/consultarEventoTipos`, {headers: this.headers}).pipe(
        map((res: any) => {
            try {
                return JSON.parse(res.text());
            }
            catch (error){
                console.log(error);
                return null;
            }  
        }));
    }

    consultarPedidosParadaDescarga(id): Observable<any[]> {
        return this._http.get(`${this._utils.url}Viajes/consultarPedidosParadaDescarga?idRuta=`+id, {headers: this.headers}).pipe(
        map((res: any) => {
            try {
                return JSON.parse(res.text());
            }
            catch (error){
                console.log(error);
                return null;
            }  
        }));
    }

    consultarPedidoEvidencias(id): Observable<any[]> {
        return this._http.get(`${this._utils.url}Viajes/consultarPedidoEvidencias?idPedido=`+id, {headers: this.headers}).pipe(
        map((res: any) => {
            try {
                return JSON.parse(res.text());
            }
            catch (error){
                console.log(error);
                return null;
            }  
        }));
    }

    agregarFotografiaEvento(params): Observable<any[]> {
        let json = JSON.stringify(params)

        return this._http.post(`${this._utils.url}Fotografia/agregarFotografiaEvento`, json, {headers: this.headers}).pipe(
        map((res: any) => {
            try {
                return JSON.parse(res.text());
            }
            catch (error){
                console.log(error);
                return null;
            }  
        }));
    }

    agregarFotografiaEvidencia(params): Observable<any[]> {
        let json = JSON.stringify(params)

        return this._http.post(`${this._utils.url}Fotografia/agregarFotografia`, json, {headers: this.headers}).pipe(
        map((res: any) => {
            try {
                return JSON.parse(res.text());
            }
            catch (error){
                console.log(error);
                return null;
            }  
        }));
    }

    descargarFiles(idRuta, tipoArchivo, idRazonSocial): Observable<any> {
        const formData = new FormData();
        formData.append('idRuta', idRuta);
        formData.append('tipoArchivo', tipoArchivo);
        formData.append('idRazonSocial', idRazonSocial);
    
        return this._http.post(`${this._utils.url}Transportista/descargarArchivos`, formData).pipe(
          map((res: any) => {
            return res.json();
          }));
      }

      guardarFiles(file, idRazonSocial, idRuta, tipoArchivo, extensionFile, idRutaTransportista, idUsuario): Observable<any> {
        const formData = new FormData();
        formData.append('archivo', file);
        formData.append('idRazonSocial', idRazonSocial);
        formData.append('idRuta', idRuta);
        formData.append('tipoArchivo', tipoArchivo);
        formData.append('extensionFile', extensionFile);
        formData.append('idRutaTransportista', idRutaTransportista);
        formData.append('idUsuario', idUsuario);
    
        return this._http.post(`${this._utils.url}Transportista/guardarArchivos`, formData).pipe(
            map((res: any) => {
                return JSON.parse(res.json());
            }));
    }

    descargarFilesFacturar(idRazonSocial, idRuta, tipoArchivo, idRutaTransportista, idUsuario): Observable<any> {
        const formData = new FormData();
        formData.append('idRazonSocial', idRazonSocial);
        formData.append('idRuta', idRuta);
        formData.append('tipoArchivo', tipoArchivo);
        formData.append('idRutaTransportista', idRutaTransportista);
        formData.append('idUsuario', idUsuario);
    
        return this._http.post(`${this._utils.url}Transportista/descargarArchivos`, formData).pipe(
          map((res: any) => {
            return res.json();
          }));
      }

    updateAsignacion(idOperador, idRemolque1, idRemolque2, idRuta): Observable<any[]> {
        return this._http.get(`${this._utils.url}Viajes/updateAsignacion?idOperador=${idOperador}&idRemolque1=${idRemolque1}&idRemolque2=${idRemolque2}&idRuta=${idRuta}`, {headers: this.headers}).pipe(
        map((res: any) => {
            try {
                return JSON.parse(res.text());
            }
            catch (error){
                console.log(error);
                return null;
            }  
        }));
    }

}